// extracted by mini-css-extract-plugin
export default {"tableContainer":"style_tableContainer__+zKEp","actions":"style_actions__z2rmV","rtl":"style_rtl__VSoR5"};